/* soraflo-push: 2026-07-09T06:27:52.225Z */
/**
 * SoraFlo — Fitment Sort
 *
 * Runs on collection pages when a fitment filter is active in the URL.
 * Reorders product cards so that the product types listed in SORT_LAST
 * always appear at the end of the visible grid.
 *
 * Automatically re-sorts after Shopify's Ajax filtering replaces the grid.
 */

(function () {
  "use strict";

  /** Product types (lowercase) that should be pushed to the END of results. */
  var SORT_LAST = ["wheels", "tyres", "tires"];

  /** Debounce delay (ms) after DOM mutations before re-sorting. */
  var DEBOUNCE = 350;

  // ── Helpers ───────────────────────────────────────────────────────────────

  function hasFitmentFilter() {
    return window.location.search.indexOf("filter.p.m.") !== -1;
  }

  function findGrid() {
    var selectors = [
      "#product-grid",
      "ul.product-grid",
      "div.product-grid",
      ".collection__products",
      ".products-grid",
      ".product-list",
      ".collection-products",
      "ul.grid.product-grid",
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  /** Walk up from a product link to find the outermost card element. */
  function cardRoot(link, grid) {
    var el = link;
    for (var i = 0; i < 8; i++) {
      var p = el.parentElement;
      if (!p || p === grid || p === document.body) break;
      el = p;
    }
    return el;
  }

  /** Return unique { handle, card } pairs for all product cards in the grid. */
  function getCards(grid) {
    var seen = Object.create(null);
    var cards = [];
    var links = grid.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute("href") || "";
      var m = href.match(/\/products\/([^?#/]+)/);
      if (!m) continue;
      var handle = m[1];
      if (seen[handle]) continue;
      seen[handle] = true;
      var card = cardRoot(links[i], grid);
      if (card && card !== grid) {
        cards.push({ handle: handle, card: card });
      }
    }
    return cards;
  }

  function fetchType(handle) {
    return fetch("/products/" + handle + ".js")
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (p) { return (p.type || "").toLowerCase().trim(); })
      .catch(function () { return ""; });
  }

  // ── Core sort ─────────────────────────────────────────────────────────────

  var sorting = false;
  var observer = null;

  function pauseObserver() {
    if (observer) observer.disconnect();
  }

  function resumeObserver() {
    if (observer) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function sort(grid) {
    if (sorting) return;
    sorting = true;
    pauseObserver(); // avoid mutation loops while we move nodes

    var cards = getCards(grid);
    if (!cards.length) {
      sorting = false;
      resumeObserver();
      return;
    }

    var fetches = cards.map(function (item) {
      return fetchType(item.handle).then(function (type) {
        item.type = type;
        return item;
      });
    });

    Promise.all(fetches).then(function (items) {
      var normal = [];
      var last   = [];
      items.forEach(function (item) {
        (SORT_LAST.indexOf(item.type) === -1 ? normal : last).push(item);
      });
      normal.concat(last).forEach(function (item) {
        grid.appendChild(item.card);
      });
    }).then(function () {
      sorting = false;
      resumeObserver();
    }, function () {
      sorting = false;
      resumeObserver();
    });
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  function init() {
    if (!hasFitmentFilter()) return;

    var grid = findGrid();
    if (!grid) return;

    // Initial sort
    sort(grid);

    // Re-sort after Shopify Ajax filtering replaces the grid DOM
    var debounceTimer = null;
    observer = new MutationObserver(function () {
      if (!hasFitmentFilter()) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var g = findGrid();
        if (g) sort(g);
      }, DEBOUNCE);
    });

    resumeObserver();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
